var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchieverTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 537,
    viewBox: "0 0 479 537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1180_192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 479,
    height: 537
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.543 5.37646C446.299 2.83738 440.842 1.23048 435.735 0.571735C431.897 0.0763475 428.133 -0.0745679 424.487 0.0372938C422.663 0.0941125 420.868 0.21662 419.106 0.395954C396.217 2.72907 379.089 14.613 379.089 14.613C379.089 14.613 372.734 19.3059 367.344 25.0783C367.305 24.4693 367.271 23.8052 367.228 23.2317C366.985 19.8723 366.715 17.2161 366.476 15.1795C366.463 15.064 366.448 14.9309 366.435 14.819H366.698C368.576 14.819 370.355 13.9525 371.099 12.5161C371.124 12.4664 371.15 12.4184 371.173 12.3687C374.106 6.45247 368.384 0 360.697 0H337.025H320.483H294.935H294.299H284.215H267.025H237.998H160.518H115.298C107.61 0 101.891 6.4507 104.821 12.3687C104.847 12.4184 104.87 12.4664 104.896 12.5161C105.642 13.9525 107.418 14.819 109.297 14.819H110.975H111.905C111.89 14.9398 111.875 15.0854 111.86 15.2114C111.583 17.596 111.263 20.9199 110.997 25.0783C105.608 19.3041 99.2512 14.613 99.2512 14.613C99.2512 14.613 89.1179 7.57997 74.0202 3.2724C67.9811 1.55009 61.1488 0.262794 53.8537 0.0355192C50.2051 -0.0763425 46.4413 0.0745729 42.6051 0.56996C40.9013 0.790133 39.1612 1.11507 37.4019 1.54476C36.5234 1.75961 35.6384 2.00108 34.7513 2.26742C32.0943 3.06821 29.4181 4.10515 26.7973 5.37469C25.923 5.79905 25.0551 6.2465 24.1957 6.72236C21.6176 8.14815 19.1141 9.80478 16.7599 11.6958C15.9752 12.3261 15.2075 12.9813 14.4569 13.6631C5.46865 21.8255 -0.807114 33.6704 0.0842458 49.0895C0.679196 59.4057 4.48346 71.3216 12.8341 84.8071C13.8747 86.4886 14.9879 88.1949 16.1735 89.9261C18.5981 93.4667 21.2124 96.9078 23.9995 100.246C28.1791 105.251 32.7468 110.024 37.6557 114.55C42.5603 119.078 47.8061 123.359 53.3355 127.382C72.0967 141.036 104.595 161.502 149.816 178.592C163.966 200.289 183.082 221.378 208.733 239.998H208.406L206.389 243.248L201.549 251.043C201.549 251.043 201.851 251.177 202.353 251.408C202.64 251.541 203.014 251.715 203.429 251.913C203.481 251.936 203.534 251.962 203.585 251.987C204.018 252.193 204.498 252.424 205.029 252.685C205.05 252.696 205.074 252.708 205.095 252.717C205.572 252.953 206.095 253.214 206.63 253.488C206.758 253.553 206.884 253.617 207.014 253.685C207.564 253.967 208.134 254.267 208.718 254.579C208.856 254.654 208.997 254.732 209.136 254.807C209.746 255.139 210.366 255.48 210.987 255.837C211.019 255.854 211.049 255.874 211.081 255.892C211.688 256.241 212.292 256.604 212.887 256.969C213.013 257.048 213.136 257.122 213.26 257.2C213.851 257.571 214.426 257.948 214.979 258.326C215.087 258.4 215.192 258.477 215.301 258.551C215.868 258.949 216.418 259.35 216.915 259.75C217.405 260.144 217.832 260.668 218.239 261.245C218.322 261.364 218.41 261.476 218.491 261.602C218.86 262.17 219.205 262.797 219.542 263.477C219.668 263.733 219.792 263.997 219.915 264.265C220.099 264.659 220.284 265.068 220.47 265.487C220.728 266.071 220.994 266.668 221.267 267.28H220.768C217.058 269.867 214.512 273.298 213.957 277.197C213.878 277.751 213.853 278.296 213.851 278.839L213.846 278.837C213.844 278.848 213.848 278.859 213.848 278.871C213.848 279.539 213.893 280.201 214.004 280.847C214.989 287.225 220.687 291.586 227.49 293.802C227.142 296.05 226.748 298.483 226.296 301.068L226.3 301.07C221.775 326.785 211.586 368.261 190.552 393.831H183.613C183.613 393.831 158.932 395.495 158.932 417.993H158.699C142.25 417.993 128.916 430.865 128.916 446.742V503.498H125.173C121.516 503.498 118.224 505.343 116.846 508.163L111.353 519.411H105.868C102.65 519.411 99.5007 521.592 98.8311 524.305L95.6922 537H99.9677H376.556H380.831L377.692 524.305C377.021 521.592 373.873 519.411 370.655 519.411H366.985L361.492 508.163C360.115 505.341 356.822 503.498 353.165 503.498H349.431V446.742C349.431 430.865 336.097 417.993 319.647 417.993H319.415C319.415 395.495 294.734 393.831 294.734 393.831H287.795C266.976 368.522 256.783 327.643 252.188 301.874L252.194 301.872C251.721 299.209 251.305 296.707 250.942 294.4C251.343 294.303 251.768 294.248 252.128 294.068C252.906 293.68 253.473 293.071 253.945 292.371C254.395 292.158 254.821 291.929 255.248 291.698C255.265 291.689 255.28 291.68 255.297 291.671C255.89 291.348 256.459 291.009 257.005 290.652C257.065 290.613 257.122 290.574 257.18 290.535C257.679 290.201 258.156 289.857 258.611 289.498C258.704 289.423 258.796 289.347 258.888 289.271C259.295 288.937 259.687 288.596 260.056 288.241C260.178 288.126 260.289 288.005 260.406 287.888C260.726 287.561 261.039 287.231 261.325 286.888C261.462 286.728 261.581 286.561 261.709 286.398C261.952 286.084 262.193 285.768 262.406 285.443C262.543 285.237 262.656 285.027 262.777 284.818C262.952 284.518 263.131 284.221 263.281 283.914C263.402 283.665 263.496 283.411 263.6 283.157C263.716 282.877 263.839 282.598 263.933 282.312C264.029 282.018 264.091 281.716 264.166 281.416C264.227 281.16 264.304 280.91 264.347 280.65C264.409 280.292 264.428 279.928 264.453 279.562C264.468 279.354 264.502 279.148 264.507 278.939C264.515 278.36 264.481 277.777 264.398 277.19C264.396 277.179 264.392 277.17 264.392 277.161C263.829 273.273 261.289 269.853 257.587 267.273H257.231C258.638 264.114 259.754 261.213 261.583 259.741C262.08 259.34 262.632 258.939 263.202 258.539C263.306 258.466 263.409 258.392 263.515 258.319C264.067 257.939 264.643 257.562 265.236 257.191C265.36 257.113 265.486 257.037 265.613 256.959C266.211 256.589 266.818 256.225 267.43 255.874C267.449 255.861 267.471 255.851 267.49 255.838C268.119 255.478 268.746 255.132 269.367 254.794C269.503 254.72 269.642 254.643 269.778 254.571C270.36 254.256 270.934 253.956 271.484 253.674C271.612 253.608 271.734 253.546 271.857 253.482C272.397 253.207 272.921 252.944 273.403 252.706C273.425 252.696 273.446 252.685 273.467 252.674C273.998 252.413 274.48 252.182 274.911 251.976C274.962 251.952 275.018 251.925 275.069 251.902C275.487 251.705 275.858 251.531 276.146 251.398C276.645 251.169 276.95 251.032 276.95 251.032L276.719 250.663C276.819 250.652 276.95 250.638 276.95 250.638C276.862 250.632 276.781 250.629 276.694 250.622L270.092 239.989H269.62C295.271 221.367 314.387 200.28 328.537 178.583C373.756 161.493 406.254 141.027 425.018 127.373C428.705 124.69 432.264 121.894 435.68 118.985C440.806 114.623 445.611 110.012 450.044 105.162C451.522 103.545 452.957 101.904 454.351 100.235C457.138 96.8989 459.753 93.4578 462.177 89.9155C463.363 88.1843 464.474 86.478 465.517 84.7965C471.895 74.4946 475.603 65.1177 477.275 56.6606C482.412 30.6093 468.04 13.3666 451.543 5.37646ZM133.293 153.954C130.739 152.883 127.937 151.661 124.953 150.285C124.875 150.248 124.791 150.211 124.713 150.175C121.716 148.792 118.539 147.256 115.236 145.564C115.146 145.52 115.059 145.472 114.969 145.427C111.675 143.733 108.259 141.887 104.785 139.886C104.661 139.815 104.538 139.742 104.414 139.671C100.968 137.679 97.4685 135.534 93.967 133.234C93.7985 133.124 93.6322 133.012 93.4659 132.902C91.7407 131.762 90.0135 130.589 88.2969 129.374C88.3011 129.376 88.3054 129.38 88.3075 129.383C78.4215 122.386 68.7957 114.15 60.7692 104.626C44.9849 85.9027 35.905 67.2715 34.0135 52.5093C33.0688 45.1282 33.9197 38.7148 36.6279 33.7414C37.306 32.4985 38.0993 31.3444 39.0098 30.2897C41.7415 27.122 45.5265 24.8298 50.3906 23.6153C72.6362 18.0577 94.9714 47.3122 110.702 51.2362C111.754 78.6494 117.409 116.789 136.477 155.259C135.524 154.875 134.547 154.479 133.507 154.042C133.434 154.014 133.364 153.984 133.293 153.954ZM109.542 45.1282C109.877 45.1211 110.206 45.0892 110.534 45.0536C110.536 45.185 110.542 45.3271 110.545 45.4585C110.21 45.3519 109.879 45.2507 109.542 45.1282ZM367.802 45.0536C368.145 45.0892 368.487 45.1247 368.834 45.13C368.482 45.2578 368.137 45.3626 367.791 45.4727C367.796 45.3359 367.8 45.1904 367.802 45.0536ZM354.515 124.605C356.568 118.435 358.321 112.35 359.816 106.393C361.311 100.438 362.546 94.6101 363.561 88.962C364.576 83.3121 365.371 77.8398 365.985 72.5894C366.879 64.9508 367.384 57.8005 367.636 51.2469C383.119 47.4311 405.015 19.0165 426.926 23.4075C427.267 23.4785 427.604 23.53 427.948 23.6153C453.893 30.0961 449.135 67.1809 417.569 104.626C395.091 131.29 360.134 147.904 341.857 155.266C346.97 144.957 351.167 134.669 354.515 124.605Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1180_192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.736 0.571268C405.033 -3.38828 379.09 14.6144 379.09 14.6144C379.09 14.6144 348.82 36.937 364.389 44.1387C379.955 51.3405 402.007 17.1357 427.955 23.6166C453.9 30.0974 449.142 67.1823 417.576 104.628C386.009 142.073 329.796 159.715 329.796 159.715L318.121 182.398C368.801 164.63 404.837 142.067 425.012 127.385C439.758 116.654 452.471 104.093 462.174 89.9293C500.108 34.5435 462.984 4.08692 435.736 0.571268Z",
    fill: "url(#paint0_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.621 104.625C449.188 67.1797 453.943 30.0949 428 23.614C402.055 17.1331 375.977 58.039 360.412 50.8372C356.203 48.8894 359.387 39.1343 360.374 35.7181C360.977 36.1691 355.237 44.1983 355.966 44.6937C372.333 55.7875 403.36 11.9076 431.811 21.0714C453.316 27.9979 456.067 61.8458 420.517 104.018C389.599 140.694 339.549 159.112 326.545 163.651L329.842 159.714C329.842 159.714 386.055 142.072 417.621 104.625Z",
    fill: "url(#paint1_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.237 8.83564C416.7 6.96063 402.385 10.2614 389.855 16.3854C383.53 19.4767 358.868 36.3305 358.952 37.055L360.242 48.1595C360.242 48.1595 399.363 17.1418 423.88 17.8645C446.806 18.5392 468.303 42.6871 438.411 90.1129C430.766 102.242 420.75 112.998 409.13 122.187C393.894 134.238 370.234 152.477 332.88 167.369C332.379 168.484 331.895 169.6 331.452 170.721C331.326 171.039 331.183 171.339 331.051 171.651C373.58 155.92 400.973 136.77 418.402 124.087C431.804 114.334 443.356 102.918 452.173 90.0437C486.655 39.7095 456.001 12.0299 431.237 8.83564Z",
    fill: "url(#paint2_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.237 8.83564C416.7 6.96063 402.385 10.2614 389.855 16.3854C383.53 19.4767 358.868 36.3305 358.952 37.055L360.242 48.1595C360.242 48.1595 399.363 17.1418 423.88 17.8645C446.806 18.5392 468.303 42.6871 438.411 90.1129C430.766 102.242 420.75 112.998 409.13 122.187C393.894 134.238 370.234 152.477 332.88 167.369C332.379 168.484 331.895 169.6 331.452 170.721C331.326 171.039 331.183 171.339 331.051 171.651C373.58 155.92 400.973 136.77 418.402 124.087C431.804 114.334 443.356 102.918 452.173 90.0437C486.655 39.7095 456.001 12.0299 431.237 8.83564Z",
    fill: "url(#paint3_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7708 104.624C29.2043 67.1789 24.449 30.0941 50.3922 23.6133C76.3376 17.1324 98.3913 51.3372 113.956 44.1354C129.523 36.9355 99.2549 14.6111 99.2549 14.6111C99.2549 14.6111 73.3096 -3.39158 42.6088 0.567972C15.3627 4.08362 -21.7631 34.5402 16.1751 89.9241C25.8777 104.088 38.5892 116.65 53.335 127.38C73.51 142.062 109.546 164.625 160.226 182.393L148.551 159.71C148.551 159.713 92.3373 142.071 60.7708 104.624Z",
    fill: "url(#paint4_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7708 104.624C29.2043 67.1789 24.449 30.0941 50.3922 23.6133C76.3376 17.1324 98.3913 51.3372 113.956 44.1354C129.523 36.9355 99.2549 14.6111 99.2549 14.6111C99.2549 14.6111 73.3096 -3.39158 42.6088 0.567972C15.3627 4.08362 -21.7631 34.5402 16.1751 89.9241C25.8777 104.088 38.5892 116.65 53.335 127.38C73.51 142.062 109.546 164.625 160.226 182.393L148.551 159.71C148.551 159.713 92.3373 142.071 60.7708 104.624Z",
    fill: "url(#paint5_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.7 161.931L148.559 159.714C148.559 159.714 117.295 149.895 88.3066 129.374C112.751 147.876 140.146 158.54 149.7 161.931Z",
    fill: "url(#paint6_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M20.8434 93.3459C-17.0948 37.962 20.031 7.50546 47.2772 3.98981C73.4017 0.619752 96.0183 13.1181 102.2 16.9302C100.437 15.4867 99.2554 14.6131 99.2554 14.6131C99.2554 14.6131 73.31 -3.38952 42.6092 0.571806C15.3609 4.08568 -21.7627 34.544 16.1755 89.9279C25.8781 104.092 38.5896 116.654 53.3354 127.384C54.2289 128.035 55.1928 128.719 56.1502 129.401C42.2019 118.98 30.1323 106.908 20.8434 93.3459Z",
    fill: "url(#paint7_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M457.492 93.3458C495.43 37.9619 458.304 7.50533 431.058 3.98968C404.933 0.61963 382.317 13.118 376.135 16.9301C377.898 15.4866 379.082 14.613 379.082 14.613C379.082 14.613 405.027 -3.38964 435.728 0.571684C462.974 4.08556 500.1 34.5439 462.162 89.9278C452.459 104.092 439.748 116.654 425 127.384C424.106 128.035 423.14 128.719 422.185 129.401C436.133 118.98 448.203 106.908 457.492 93.3458Z",
    fill: "url(#paint8_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7664 104.625C29.1999 67.1797 24.4445 30.0949 50.3878 23.614C76.3332 17.1331 102.411 58.039 117.975 50.8372C122.183 48.8894 119.001 39.1343 118.014 35.7181C117.41 36.1691 123.151 44.1983 122.422 44.6937C106.055 55.7875 75.0281 11.9076 46.5771 21.0714C25.0715 27.9979 22.3206 61.8458 57.8705 104.018C88.7888 140.694 138.839 159.112 151.843 163.651L148.546 159.714C148.546 159.714 92.3329 142.072 60.7664 104.625Z",
    fill: "url(#paint9_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1198 8.83564C61.6567 6.96063 75.9717 10.2614 88.5019 16.3854C94.8267 19.4767 119.488 36.3305 119.405 37.055L118.115 48.1595C118.115 48.1595 78.9934 17.1418 54.4767 17.8645C31.5509 18.5392 10.0538 42.6871 39.9463 90.1129C47.5911 102.242 57.6071 112.998 69.2268 122.187C84.4631 134.238 108.122 152.477 145.476 167.369C145.975 168.484 146.462 169.6 146.905 170.721C147.031 171.039 147.174 171.339 147.306 171.651C104.777 155.92 77.3834 136.77 59.955 124.087C46.5526 114.334 35.0012 102.918 26.1814 90.0437C-8.29588 39.7095 22.3558 12.0299 47.1198 8.83564Z",
    fill: "url(#paint10_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1198 8.83564C61.6567 6.96063 75.9717 10.2614 88.5019 16.3854C94.8267 19.4767 119.488 36.3305 119.405 37.055L118.115 48.1595C118.115 48.1595 78.9934 17.1418 54.4767 17.8645C31.5509 18.5392 10.0538 42.6871 39.9463 90.1129C47.5911 102.242 57.6071 112.998 69.2268 122.187C84.4631 134.238 108.122 152.477 145.476 167.369C145.975 168.484 146.462 169.6 146.905 170.721C147.031 171.039 147.174 171.339 147.306 171.651C104.777 155.92 77.3834 136.77 59.955 124.087C46.5526 114.334 35.0012 102.918 26.1814 90.0437C-8.29588 39.7095 22.3558 12.0299 47.1198 8.83564Z",
    fill: "url(#paint11_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.259 12.1162C110.186 26.7399 93.6595 169.387 224.44 250.648H253.914C384.695 169.385 368.171 26.7399 366.096 12.1162H112.259Z",
    fill: "url(#paint12_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.259 12.1162C110.186 26.7399 93.6595 169.387 224.44 250.648H253.914C384.695 169.385 368.171 26.7399 366.096 12.1162H112.259Z",
    fill: "url(#paint13_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.662 12.1162H112.259C110.186 26.7399 93.6595 169.387 224.44 250.648H225.184C100.999 169.387 116.692 26.7399 118.662 12.1162Z",
    fill: "url(#paint14_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.088 12.1162H359.684C361.654 26.7399 377.347 169.387 253.162 250.648H253.906C384.687 169.387 368.16 26.7399 366.088 12.1162Z",
    fill: "url(#paint15_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.045 12.1162C147.572 26.7399 135.837 169.387 228.7 250.648H249.63C342.494 169.385 330.759 26.7399 329.285 12.1162H149.045Z",
    fill: "url(#paint16_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.478 12.1162C137.849 26.7399 124.867 169.387 227.605 250.648H250.76C353.498 169.385 340.516 26.7399 338.887 12.1162H139.478Z",
    fill: "url(#paint17_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.853 12.1162H166.013C164.686 26.7399 154.112 169.387 237.793 250.648H249.071C332.755 169.387 322.18 26.7399 320.853 12.1162Z",
    fill: "url(#paint18_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.251 12.1162H182.606C181.563 26.7399 173.257 169.387 238.998 250.648H247.859C313.602 169.387 305.294 26.7399 304.251 12.1162Z",
    fill: "url(#paint19_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.477 167.057C308.48 105.801 311.312 37.3861 310.497 28.4194L226.822 39.2061C232.328 78.7217 251.315 108.665 281.477 167.057Z",
    fill: "url(#paint20_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M126.287 39.2065H125.104C124.289 48.1732 127.273 113.871 163.155 173.213C186.633 127.76 191.775 95.8209 195.502 65.2578C191.566 64.1978 149.68 50.0446 126.287 39.2065Z",
    fill: "url(#paint21_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.444 12.1162H215.461C214.947 26.7399 210.851 169.387 243.268 250.648H247.637C280.055 169.387 275.958 26.7399 275.444 12.1162Z",
    fill: "url(#paint22_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M196.789 109.626C195.974 118.593 199.817 179.312 235.699 238.654C234.015 178.613 239.653 152.047 243.378 121.484C239.44 120.42 196.789 109.626 196.789 109.626Z",
    fill: "url(#paint23_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M112.243 12.1162C111.872 14.7423 111.043 21.5587 110.676 31.3511C133.832 28.8209 204.667 21.4025 239.162 21.4025C273.658 21.4025 344.494 28.8209 367.648 31.3511C367.281 21.5605 366.451 14.7423 366.08 12.1162H112.243Z",
    fill: "#C89472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.7 0.0022583H237.997H115.296C107.609 0.0022583 101.89 6.45296 104.82 12.371C104.845 12.4207 104.869 12.4686 104.894 12.5183C105.641 13.9548 107.417 14.8213 109.296 14.8213H237.995H366.696C368.575 14.8213 370.353 13.9548 371.097 12.5183C371.123 12.4686 371.148 12.4207 371.172 12.371C374.108 6.45296 368.387 0.0022583 360.7 0.0022583Z",
    fill: "url(#paint24_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.025 0.0022583H284.213V14.8213H337.025V0.0022583Z",
    fill: "url(#paint25_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.035 0.0022583H320.494V14.8213H337.035V0.0022583Z",
    fill: "url(#paint26_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.02 0.0022583H160.513C159.731 4.96146 158.876 9.92066 157.752 14.8213H267.163C267.285 9.87805 267.323 4.94015 267.02 0.0022583Z",
    fill: "url(#paint27_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.067 2.84772H211.541C211.369 6.84633 210.972 10.8218 210.795 14.8187H244.647C244.537 10.8307 244.274 6.841 244.067 2.84772Z",
    fill: "url(#paint28_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.238 2.84772H143.773V14.8187H194.238V2.84772Z",
    fill: "url(#paint29_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.97 128.253C160.257 125.036 127.396 78.3343 126.424 77.3488C128.469 122.825 144.925 200.216 226.094 250.651H251.939C320.527 208.033 342.905 146.169 349.43 100.573C334.032 118.906 276.499 128.713 261.97 128.253Z",
    fill: "url(#paint30_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.923 44.1285L323.973 27.0066L304.338 48.4751L346.072 50.62L304.476 54.7358L346.072 93.1026L299.256 59.244L296.085 86.0979L291.737 59.3577L269.368 75.1213L286.323 55.0128L248.225 52.3725L286.186 48.7504L258.034 21.5822L291.404 44.2439L294.575 -4.08032L298.923 44.1285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.942 251.044H201.545L208.403 240H270.084L276.942 251.044Z",
    fill: "url(#paint31_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M274.448 251.044H276.951L270.093 240H268.053C268.857 241.396 273.864 249.75 274.448 251.044Z",
    fill: "url(#paint32_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.399 240H208.403L201.545 251.044H203.903C204.582 250 208.979 242.777 210.399 240Z",
    fill: "url(#paint33_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.231 251.044H266.669C264.504 248.86 260.647 240.986 260.225 240H256.137C256.631 243.67 259.231 251.044 259.231 251.044Z",
    fill: "url(#paint34_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.737 241.415C235.826 240.951 235.961 240.475 236.091 240.003H227.742C226.616 243.778 225.115 247.475 223.26 251.047H234.677C234.813 247.821 235.133 244.613 235.737 241.415Z",
    fill: "url(#paint35_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.691 240H248.895C249.937 242.307 250.857 244.67 251.959 246.952C252.624 248.331 253.337 249.693 254.081 251.042H242.89C242.839 247.363 242.766 243.681 242.691 240Z",
    fill: "url(#paint36_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.354 240H215.916C215.317 241.385 211.909 248.931 210.148 251C210.135 251.014 210.122 251.028 210.109 251.042H220.13C220.087 250.071 223.171 240 224.354 240Z",
    fill: "url(#paint37_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.244 251.045H201.545C201.545 251.045 211.629 255.505 216.913 259.752C222.195 264 221.477 280.142 239.244 280.142C257.012 280.142 256.293 264 261.575 259.752C266.857 255.505 276.944 251.045 276.944 251.045H239.244Z",
    fill: "url(#paint38_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.253 251.045H211.363C211.363 251.045 218.825 255.505 222.733 259.752C226.642 264 229.96 287.881 239.256 280.142C242.746 277.235 251.869 264 255.778 259.752C259.686 255.505 267.146 251.045 267.146 251.045H239.253Z",
    fill: "url(#paint39_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.365 251.044C255.99 253.325 252.235 256.729 250.821 260.578C248.507 266.882 246.076 274.382 238.924 280.113C239.035 280.117 239.131 280.163 239.239 280.138C248.682 277.999 251.853 263.996 255.762 259.749C259.67 255.5 267.13 251.042 267.13 251.042H258.365V251.044Z",
    fill: "url(#paint40_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.26 251.045H226.084C226.244 251.592 226.427 252.116 226.56 252.693C227.496 256.762 231.39 260.591 233.328 264.492C234.931 267.721 236.194 271.019 237.358 274.35C239.879 271.805 241.301 271.23 243.429 268.474C244.909 259.575 248.052 254.445 251.26 251.045Z",
    fill: "url(#paint41_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.685 251.045H220.719C224.523 255.582 226.931 260.31 230.078 265.234C232.509 269.035 236.804 271.954 239.887 274.184C239.51 266.285 239.742 258.646 242.685 251.045Z",
    fill: "url(#paint42_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.336 251.407C204.801 252.543 212.508 256.215 216.905 259.752C221.242 263.24 221.553 274.724 231.346 278.733C233.427 281.628 235.954 282.874 239.236 280.141C257.003 280.141 256.285 264 261.567 259.752C265.964 256.217 273.668 252.543 276.135 251.407H202.336Z",
    fill: "url(#paint43_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.545 251.046C201.545 251.046 231.386 247.484 276.942 250.65C276.942 250.65 246.825 254.137 201.545 251.046Z",
    fill: "#FDF5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.545 251.046C201.545 251.046 231.386 247.484 276.942 250.65C276.942 250.65 246.825 254.137 201.545 251.046Z",
    fill: "url(#paint44_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.498 243.878L270.091 240.002H208.41L206.393 243.252C230.879 246.842 245.885 247.263 272.498 243.878Z",
    fill: "url(#paint45_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44 527.517V446.749C349.44 430.872 336.106 418.001 319.656 418.001H158.702C142.252 418.001 128.918 430.872 128.918 446.749V527.517H349.44Z",
    fill: "url(#paint46_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.855 508.171L111.361 519.419H366.992L361.499 508.171C360.121 505.349 356.829 503.506 353.171 503.506H125.182C121.525 503.506 118.232 505.351 116.855 508.171Z",
    fill: "url(#paint47_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.499 508.171C360.121 505.349 356.829 503.506 353.171 503.506H125.182C121.525 503.506 118.232 505.351 116.855 508.171L111.361 519.419H114.36L119.723 509.946C121.068 507.571 124.282 506.019 127.854 506.019H350.497C354.067 506.019 357.283 507.572 358.628 509.946L363.991 519.419H366.99L361.499 508.171Z",
    fill: "url(#paint48_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.813 278.224H239.162H229.511C229.511 278.224 221.546 368.392 181.723 403.025H239.162H296.601C256.778 368.392 248.813 278.224 248.813 278.224Z",
    fill: "#F4BE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.813 278.224H239.162H229.511C229.511 278.224 221.546 368.392 181.723 403.025H239.162H296.601C256.778 368.392 248.813 278.224 248.813 278.224Z",
    fill: "url(#paint49_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.709 278.224H239.169H230.628C230.628 278.224 223.58 368.392 188.342 403.025H239.169H289.995C254.757 368.392 247.709 278.224 247.709 278.224Z",
    fill: "#F4BE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.626 278.224H239.156H231.686C231.686 278.224 225.521 368.392 194.703 403.025H239.156H283.609C252.791 368.392 246.626 278.224 246.626 278.224Z",
    fill: "url(#paint50_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.126 278.224H238.121C238.121 278.224 233.99 368.392 213.34 403.025H243.126H272.912C252.259 368.392 243.126 278.224 243.126 278.224Z",
    fill: "url(#paint51_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.127 278.224H240.809C240.809 278.224 238.896 368.392 229.33 403.025H243.127H256.924C247.358 368.392 243.127 278.224 243.127 278.224Z",
    fill: "url(#paint52_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.289 301.073C235.512 305.137 247.56 303.047 252.194 301.879C249.68 287.8 248.82 278.224 248.82 278.224H229.518C229.518 278.224 228.637 287.628 226.289 301.073Z",
    fill: "#D39F10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.728 393.837H239.166H183.603C183.603 393.837 158.922 395.501 158.922 417.999H239.166H319.409C319.409 395.501 294.728 393.837 294.728 393.837Z",
    fill: "#F4C229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.728 393.837H239.166H183.603C183.603 393.837 158.922 395.501 158.922 417.999H239.166H319.409C319.409 395.501 294.728 393.837 294.728 393.837Z",
    fill: "url(#paint53_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.695 397.687H239.173H186.651C186.651 397.687 163.322 399.085 163.322 417.998H239.173H315.024C315.026 399.085 291.695 397.687 291.695 397.687Z",
    fill: "#F4C229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.181 397.689H186.659C186.659 397.689 183.042 397.924 178.665 399.335C176.999 403.998 172.056 418 172.743 418H239.181H288.803C287.103 414.701 282.418 399.953 281.154 397.687H239.181V397.689Z",
    fill: "url(#paint54_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.441 418H269.857L263.441 397.687H253.132L252.441 418Z",
    fill: "url(#paint55_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.204 397.687L191.109 418H245.45V397.687H195.204Z",
    fill: "url(#paint56_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.579 267.285H220.764C217.054 269.872 214.508 273.302 213.953 277.201C212.582 286.848 223.809 295.475 239.171 295.475C254.536 295.475 265.763 286.85 264.39 277.201C263.835 273.3 261.289 269.872 257.579 267.285Z",
    fill: "url(#paint57_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.566 267.285H220.751C217.041 269.872 214.495 273.302 213.94 277.201C212.526 287.148 223.788 295.568 239.158 295.475C254.527 295.383 265.729 286.706 264.377 277.201C263.822 273.3 261.276 269.872 257.566 267.285Z",
    fill: "url(#paint58_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.853 267.285H222.474C219.111 269.872 216.801 273.302 216.298 277.201C215.055 286.848 225.233 295.475 239.164 295.475C253.093 295.475 263.274 286.85 262.03 277.201C261.527 273.3 259.218 269.872 255.853 267.285Z",
    fill: "url(#paint59_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.166 267.285H227.189C224.773 269.872 223.114 273.302 222.752 277.201C221.858 286.848 229.17 295.475 239.178 295.475C249.185 295.475 256.497 286.85 255.602 277.201C255.239 273.3 253.582 269.872 251.166 267.285Z",
    fill: "url(#paint60_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.155 267.285H234.068C232.771 269.872 231.895 273.302 231.731 277.201C231.328 286.848 235.392 295.475 240.853 295.475C246.314 295.475 250.232 286.85 249.66 277.201C249.43 273.3 248.496 269.872 247.155 267.285Z",
    fill: "url(#paint61_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M264.389 277.202C264.364 277.018 264.276 276.844 264.24 276.663C250.716 288.181 229.351 286.78 213.84 278.843C213.819 290.523 228.839 296.301 240.523 295.427C240.819 295.404 241.099 295.493 241.385 295.395C255.634 294.58 265.692 286.356 264.389 277.202Z",
    fill: "#D39F10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.819 537.009L377.68 524.314C377.008 521.601 373.86 519.42 370.643 519.42H105.858C102.64 519.42 99.4902 521.601 98.8206 524.314L95.6816 537.009H380.819Z",
    fill: "#6A2E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68 524.314C377.008 521.601 373.86 519.42 370.643 519.42H105.858C102.64 519.42 99.4902 521.601 98.8206 524.314L95.6816 537.009H99.9572L103.002 526.681C103.653 524.474 106.706 522.7 109.828 522.7H366.674C369.796 522.7 372.85 524.474 373.5 526.681L376.545 537.009H380.821L377.68 524.314Z",
    fill: "url(#paint62_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.069 477.929V445.486C314.702 445.486 307.916 439.837 307.916 432.868H167.934C167.934 439.837 161.149 445.486 152.781 445.486V477.929C161.149 477.929 167.934 483.579 167.934 490.546H307.916C307.916 483.577 314.702 477.929 323.069 477.929Z",
    fill: "url(#paint63_radial_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.496 476.437V446.979C312.382 446.979 305.803 441.849 305.803 435.523H170.073C170.073 441.851 163.495 446.979 155.381 446.979V476.437C163.495 476.437 170.073 481.567 170.073 487.893H305.803C305.803 481.565 312.382 476.437 320.496 476.437Z",
    fill: "url(#paint64_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M310.71 440.132C308.963 438.076 307.914 435.58 307.914 432.868H298.077C289.208 452.666 266.967 490.546 266.967 490.546H277.482C277.482 490.546 309.878 441.963 310.71 440.132Z",
    fill: "url(#paint65_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M197.463 432.868L165.041 483.183C166.843 485.259 167.935 487.789 167.935 490.546H176.486L218.275 432.868H197.463Z",
    fill: "url(#paint66_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 439.929C181.04 441.658 179.358 443.059 177.281 443.059C175.204 443.059 173.521 441.658 173.521 439.929C173.521 438.199 175.204 436.798 177.281 436.798C179.356 436.798 181.04 438.201 181.04 439.929Z",
    fill: "#7E5436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.038 439.928C180.038 441.206 178.794 442.241 177.259 442.241C175.724 442.241 174.48 441.206 174.48 439.928C174.48 438.649 175.724 437.614 177.259 437.614C178.792 437.614 180.038 438.651 180.038 439.928Z",
    fill: "url(#paint67_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.341 439.927C302.341 441.657 300.657 443.058 298.582 443.058C296.505 443.058 294.822 441.657 294.822 439.927C294.822 438.198 296.505 436.797 298.582 436.797C300.657 436.797 302.341 438.2 302.341 439.927Z",
    fill: "#7E5436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36 439.928C301.36 441.206 300.117 442.241 298.581 442.241C297.046 442.241 295.803 441.206 295.803 439.928C295.803 438.649 297.046 437.614 298.581 437.614C300.117 437.614 301.36 438.651 301.36 439.928Z",
    fill: "url(#paint68_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 483.362C181.04 485.091 179.358 486.492 177.281 486.492C175.204 486.492 173.521 485.091 173.521 483.362C173.521 481.634 175.204 480.231 177.281 480.231C179.356 480.231 181.04 481.632 181.04 483.362Z",
    fill: "#7E5436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.038 483.36C180.038 484.639 178.794 485.674 177.259 485.674C175.724 485.674 174.48 484.639 174.48 483.36C174.48 482.082 175.724 481.047 177.259 481.047C178.792 481.047 180.038 482.082 180.038 483.36Z",
    fill: "url(#paint69_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.341 483.362C302.341 485.091 300.657 486.492 298.582 486.492C296.505 486.492 294.822 485.091 294.822 483.362C294.822 481.634 296.505 480.231 298.582 480.231C300.657 480.231 302.341 481.632 302.341 483.362Z",
    fill: "#7E5436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36 483.36C301.36 484.639 300.117 485.674 298.581 485.674C297.046 485.674 295.803 484.639 295.803 483.36C295.803 482.082 297.046 481.047 298.581 481.047C300.117 481.047 301.36 482.082 301.36 483.36Z",
    fill: "url(#paint70_linear_1180_192)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M371.102 12.5183C371.127 12.4686 371.153 12.4207 371.176 12.371C374.108 6.45473 368.387 0.0022583 360.7 0.0022583H237.997H115.296C107.609 0.0022583 101.89 6.45296 104.82 12.371C104.845 12.4207 104.869 12.4686 104.894 12.5183C105.641 13.9548 107.417 14.8213 109.296 14.8213H110.974C109.121 14.8213 107.364 14.1217 106.63 12.9605C106.604 12.9214 106.579 12.8806 106.555 12.8415C103.662 8.06163 109.306 2.8503 116.893 2.8503H237.995H359.096C366.683 2.8503 372.33 8.06341 369.434 12.8415C369.408 12.8823 369.385 12.9214 369.359 12.9605C368.624 14.1199 366.869 14.8213 365.014 14.8213H366.692C368.577 14.8213 370.355 13.953 371.102 12.5183Z",
    fill: "url(#paint71_radial_1180_192)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.188 92.5305) scale(199.645 166.235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#FFD44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FEE471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#FBD46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6536,
    stopColor: "#F6BA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7027,
    stopColor: "#EF9561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7093,
    stopColor: "#EE9060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(263.064 92.7756) rotate(180) scale(155.028 129.084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#BD4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1180_192",
    x1: 476.947,
    y1: 70.2445,
    x2: 345.687,
    y2: 106.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0797,
    stopColor: "#C38F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3521,
    stopColor: "#C28543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3878,
    stopColor: "#C98943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4132,
    stopColor: "#D48F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4225,
    stopColor: "#DB9342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6578,
    stopColor: "#AC6838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#F0C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9345,
    stopColor: "#EFC26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9583,
    stopColor: "#ECB967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9775,
    stopColor: "#E7AB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#DF9856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1180_192",
    x1: 476.947,
    y1: 70.2445,
    x2: 345.687,
    y2: 106.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0797,
    stopColor: "#C38F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3521,
    stopColor: "#C28543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3878,
    stopColor: "#C98943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4132,
    stopColor: "#D48F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4225,
    stopColor: "#DB9342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6578,
    stopColor: "#AC6838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#F0C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9345,
    stopColor: "#EFC26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9583,
    stopColor: "#ECB967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9775,
    stopColor: "#E7AB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#DF9856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8F52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.193 92.5289) scale(199.646 166.236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#FFD44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FEE471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#FBD46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6536,
    stopColor: "#F6BA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7027,
    stopColor: "#EF9561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7093,
    stopColor: "#EE9060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.193 92.5289) scale(199.646 166.236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6203,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.874 145.891) scale(54.7495 45.5874)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2948 72.4924) scale(122.394 101.912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(463.041 72.4923) rotate(180) scale(122.394 101.912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.325 92.7756) scale(155.028 129.084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#BD4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1180_192",
    x1: 1.41098,
    y1: 70.2445,
    x2: 132.672,
    y2: 106.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0797,
    stopColor: "#C38F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3521,
    stopColor: "#C28543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3878,
    stopColor: "#C98943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4132,
    stopColor: "#D48F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4225,
    stopColor: "#DB9342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6578,
    stopColor: "#AC6838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#F0C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9345,
    stopColor: "#EFC26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9583,
    stopColor: "#ECB967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9775,
    stopColor: "#E7AB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#DF9856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1180_192",
    x1: 1.41098,
    y1: 70.2445,
    x2: 132.672,
    y2: 106.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0797,
    stopColor: "#C38F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3521,
    stopColor: "#C28543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3878,
    stopColor: "#C98943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4132,
    stopColor: "#D48F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4225,
    stopColor: "#DB9342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6578,
    stopColor: "#AC6838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#F0C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9345,
    stopColor: "#EFC26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9583,
    stopColor: "#ECB967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9775,
    stopColor: "#E7AB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#DF9856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8F52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.95 0.628911) scale(279.245 232.514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6203,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.95 0.628911) scale(279.245 232.514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6203,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.735 4.45812) scale(297.543 247.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6203,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.727 4.45812) scale(297.543 247.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.421 0.628905) scale(198.29 232.512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6203,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1180_192",
    x1: 239.182,
    y1: 238.486,
    x2: 239.182,
    y2: 11.4394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#7C3C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#83441A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7929,
    stopColor: "#8E5123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#9E642F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#B37C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CD9B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#EABE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.808 12.1164) scale(240.419 200.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.295 12.1164) scale(188.873 200.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.838 28.42) scale(196.256 163.414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.053 34.8947) scale(131.402 109.412)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.373 12.1164) scale(93.1382 200.185)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.244 105.473) scale(124.978 104.064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1180_192",
    x1: 104.711,
    y1: 7.41105,
    x2: 372.628,
    y2: 7.41105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#FFD44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#F5F09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1862,
    stopColor: "#F5EE9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    stopColor: "#F4E996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    stopColor: "#F3DE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2515,
    stopColor: "#F1D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#F0C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3116,
    stopColor: "#EFC26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#EDBB61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#EAAF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    stopColor: "#E8AA4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5136,
    stopColor: "#FCE16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5807,
    stopColor: "#FDE473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#F9D476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7047,
    stopColor: "#F2BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7093,
    stopColor: "#F1B87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1180_192",
    x1: 286.98,
    y1: 7.41105,
    x2: 340.216,
    y2: 7.41105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    stopColor: "#FFE76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#FFDE5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.631 7.41105) scale(19.7035 16.4062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.993 7.41105) scale(94.9315 79.045)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    stopColor: "#FFE76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#FFDE5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.011 8.8339) scale(94.9292 63.8588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1180_192",
    x1: 141.426,
    y1: 8.83373,
    x2: 211.368,
    y2: 8.83373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#7F4018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5596,
    stopColor: "#8E5223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6228,
    stopColor: "#A76F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6919,
    stopColor: "#CA974F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7575,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.911 42.5739) scale(244.873 203.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3797,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4538,
    stopColor: "#FADE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#ECBD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#DA9032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1180_192",
    x1: 260.8,
    y1: 245.523,
    x2: 219.89,
    y2: 245.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    stopColor: "#F1AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8877,
    stopColor: "#F4BE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1180_192",
    x1: 272.53,
    y1: 235.137,
    x2: 272.443,
    y2: 282.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1180_192",
    x1: 205.999,
    y1: 235.015,
    x2: 205.912,
    y2: 282.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1180_192",
    x1: 259.712,
    y1: 245.523,
    x2: 203.901,
    y2: 245.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#7C3C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#83441A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7929,
    stopColor: "#8E5123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#9E642F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#B37C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CD9B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#EABE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1180_192",
    x1: 225.598,
    y1: 245.293,
    x2: 242.831,
    y2: 246.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5696,
    stopColor: "#7D3D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6598,
    stopColor: "#86481D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7449,
    stopColor: "#955A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8267,
    stopColor: "#AB7338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9062,
    stopColor: "#C6934D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#E8BA66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.008 245.523) rotate(180) scale(12.2952 10.2376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1180_192",
    x1: 260.808,
    y1: 245.523,
    x2: 219.899,
    y2: 245.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1101,
    stopColor: "#FFD951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2201,
    stopColor: "#FFCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFD233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#FFDD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9004,
    stopColor: "#FFE485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE791"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1180_192",
    x1: 260.8,
    y1: 265.594,
    x2: 219.89,
    y2: 265.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    stopColor: "#F1AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8877,
    stopColor: "#F4BE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1180_192",
    x1: 251.68,
    y1: 266.36,
    x2: 221.414,
    y2: 266.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1101,
    stopColor: "#FFD951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2201,
    stopColor: "#FFCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFD233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#FFDD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9004,
    stopColor: "#FFE485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE791"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1180_192",
    x1: 246.185,
    y1: 264.978,
    x2: 258.697,
    y2: 266.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#7C3C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#83441A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7929,
    stopColor: "#8E5123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#9E642F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#B37C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CD9B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#EABE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.239 265.593) scale(23.2715 19.3771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1180_192",
    x1: 228.329,
    y1: 262.846,
    x2: 238.968,
    y2: 261.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5696,
    stopColor: "#7D3D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6598,
    stopColor: "#86481D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7449,
    stopColor: "#955A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8267,
    stopColor: "#AB7338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9062,
    stopColor: "#C6934D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#E8BA66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1180_192",
    x1: 238.381,
    y1: 272.746,
    x2: 238.962,
    y2: 251.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4225,
    stopColor: "#ECC972"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.537 250.832) scale(35.9073 29.8984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.201 255.317) scale(43.4653 36.1915)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4225,
    stopColor: "#ECC972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1180_192",
    x1: 338.155,
    y1: 427.849,
    x2: 162.901,
    y2: 557.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#A5422D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#6A2E25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.177 511.464) scale(90.7922 59.0273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.177 511.463) scale(90.631 75.4643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.274 338.896) scale(45.67 38.0273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1180_192",
    x1: 239.157,
    y1: 390.288,
    x2: 239.157,
    y2: 280.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#7C3C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#83441A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7929,
    stopColor: "#8E5123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#9E642F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#B37C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CD9B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#EABE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1180_192",
    x1: 221.925,
    y1: 340.624,
    x2: 275.753,
    y2: 340.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1101,
    stopColor: "#FFD951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2201,
    stopColor: "#FFCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFD233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#FFDD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9004,
    stopColor: "#FFE485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(243.126 340.624) scale(43.6147 45.2704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.165 405.919) scale(57.6609 48.0116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.153 407.845) scale(58.045 40.6273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    stopColor: "#FFE76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#FFDE5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.137 407.843) scale(58.8487 41.1899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1180_192",
    x1: 191.11,
    y1: 407.844,
    x2: 245.45,
    y2: 407.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#7C3C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#83441A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7929,
    stopColor: "#8E5123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#9E642F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#B37C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CD9B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#EABE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.979 259.376) scale(42.8731 35.6984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    stopColor: "#F4BE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8877,
    stopColor: "#F4BE52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.105 277.962) scale(22.6638 18.871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.897 259.376) scale(38.8731 35.6984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    stopColor: "#F1AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8877,
    stopColor: "#F4BE52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1180_192",
    x1: 222.678,
    y1: 281.38,
    x2: 255.676,
    y2: 281.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#C08443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    stopColor: "#BE8242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3909,
    stopColor: "#B87B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#AD7036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9D5F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#88491D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4652,
    stopColor: "#7A3A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#7C3C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    stopColor: "#83441A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7929,
    stopColor: "#8E5123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#9E642F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#B37C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CD9B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#EABE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C46C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.301 267.792) scale(25.5987 21.3148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    stopColor: "#FFE76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8262,
    stopColor: "#FFDE5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1180_192",
    x1: 238.249,
    y1: 516.07,
    x2: 238.249,
    y2: 537.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#A5422D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4769,
    stopColor: "#8A3929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#6A2E25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.926 461.707) scale(64.9961 54.1192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF18D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1180_192",
    x1: 167.244,
    y1: 486.356,
    x2: 312.832,
    y2: 413.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2834,
    stopColor: "#CDA85A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1180_192",
    x1: 172.045,
    y1: 502.061,
    x2: 323.032,
    y2: 426.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2834,
    stopColor: "#CDA85A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1180_192",
    x1: 156.819,
    y1: 472.221,
    x2: 327.525,
    y2: 386.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#F6C054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2834,
    stopColor: "#CDA85A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    stopColor: "#FFEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFF071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5912,
    stopColor: "#FFF171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#FFE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    stopColor: "#FFD44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1180_192",
    x1: 176.1,
    y1: 438.539,
    x2: 178.011,
    y2: 441.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61563A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1180_192",
    x1: 297.422,
    y1: 438.539,
    x2: 299.333,
    y2: 441.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61563A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1180_192",
    x1: 176.1,
    y1: 481.971,
    x2: 178.011,
    y2: 485.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61563A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1180_192",
    x1: 297.422,
    y1: 481.971,
    x2: 299.333,
    y2: 485.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61563A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_1180_192",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.999 7.41105) scale(94.932 79.0454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    stopColor: "#FFEA72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieverTrophy);
export default __webpack_public_path__ + "static/media/Achiever_trophy.26c0b571ccc3b39dc9dd0388ce7cb746.svg";
export { ForwardRef as ReactComponent };